export const INACTIVITY_LIMIT = 120000; // 2 minutes
export const COUNTDOWN_SECONDS = 18 * 60; // 18 minutes countdown before logout (shown as min:sec)
export const SESSION_TIMEOUT_KEY = "sessionTimeoutShown";
export const COUNTDOWN_START_KEY = "countdownStartTimestamp";
export const ACTION_COMPLETED_KEY = "countdownActionCompleted";
